import { render, staticRenderFns } from "./VariationDetailsPopin.vue?vue&type=template&id=1a080a48&"
import script from "./VariationDetailsPopin.vue?vue&type=script&lang=js&"
export * from "./VariationDetailsPopin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a080a48')) {
      api.createRecord('1a080a48', component.options)
    } else {
      api.reload('1a080a48', component.options)
    }
    module.hot.accept("./VariationDetailsPopin.vue?vue&type=template&id=1a080a48&", function () {
      api.rerender('1a080a48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/option/VariationDetailsPopin.vue"
export default component.exports